export default __webpack_public_path__ + "static/media/knit.50379afb.jpg";